import * as React from "react";
import { forwardRef } from "react";
const SvgBarReport = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 32 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M7 14H18",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7 19H13",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7 24.0146H11",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M13 31.0146H3C1.89543 31.0146 1 30.1192 1 29.0146V8.01465C1 6.91008 1.89543 6.01465 3 6.01465H8C8 3.25322 10.2386 1.01465 13 1.01465C15.7614 1.01465 18 3.25322 18 6.01465H23C24.1046 6.01465 25 6.91008 25 8.01465V11.0146",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M13 5.01465C13.2761 5.01465 13.5 5.23851 13.5 5.51465C13.5 5.79079 13.2761 6.01465 13 6.01465C12.7239 6.01465 12.5 5.79079 12.5 5.51465C12.5 5.23851 12.7239 5.01465 13 5.01465",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M20.0005 30.3824H24.0019",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M22.0012 30.3824V24.6204",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M27.1489 19.6779C27.2918 19.5406 27.3345 19.3342 27.2571 19.1549C27.1798 18.9756 26.9976 18.8586 26.7954 18.8585H17.2061C17.0039 18.8586 16.8218 18.9756 16.7444 19.1549C16.6671 19.3342 16.7098 19.5406 16.8527 19.6779L22.0011 24.6205L27.1489 19.6779Z",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M25.0522 18.859C25.019 18.7007 25.0022 18.5397 25.0022 18.3782C25.0034 17.2989 25.7552 16.3532 26.8393 16.0674C27.9234 15.7816 29.0729 16.226 29.6481 17.1534C30.2233 18.0807 30.0826 19.2626 29.3043 20.0415C28.5259 20.8203 27.3016 21.0042 26.3127 20.491",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgBarReport);
export default ForwardRef;
